<template><div>
  <h1 class="fdd-md--h1">fd-shell-bar-action</h1>
<h2 class="fdd-md--h2">Props</h2>
<h3 class="fdd-md--h3">desktopOnly</h3>
<p class="fdd-md--p"><strong>Type:</strong> <code>Boolean</code></p>
<p class="fdd-md--p"><strong>Default:</strong> <code>false</code></p>
<h3 class="fdd-md--h3">mobileOnly</h3>
<p class="fdd-md--p"><strong>Type:</strong> <code>Boolean</code></p>
<p class="fdd-md--p"><strong>Default:</strong> <code>false</code></p>
<h2 class="fdd-md--h2">Slots</h2>
<h3 class="fdd-md--h3">default</h3>

  </div></template>
  <script>
  export default {
    mixins: [{
 data() {
  return {
    fddComponentApi: {"componentDesc":{"default":[]},"name":"fd-shell-bar-action","props":[{"name":"desktopOnly","type":"Boolean","describe":[],"default":"false"},{"name":"mobileOnly","type":"Boolean","describe":[],"default":"false"}],"slots":[{"name":"default","describe":"","backerDesc":"","bindings":{},"scoped":false,"target":"template"}]}
  };
 }
}
]
  }
  </script>
  